import Image from "@Components/Image";
import config from "@Config/index";
import { AppState } from "@Store/index";
import {
  AMBER_USER_WEBSITE_CONFIGURABLE_COMPONENTS,
  UAL_SALES_BANNER_PARTNER_IDS,
} from "constants/index";
import { shallowEqual, useSelector } from "react-redux";
import styles from "./SearchHeadingContent.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";

const ApplicationConfigBanner = () => {
  const { configComponents, regionId, filters } = useSelector(
    ({ appData, searchPageData }: AppState) => ({
      configComponents: appData.configComponents,
      regionId: searchPageData?.region?.id,
      filters: searchPageData?.filters,
    }),
    shallowEqual,
  );
  const { isWhitelabel, partner_id } = useWhitelabel();

  const searchPageTopBannerConfig = configComponents?.filter(
    (configComponent: any) =>
      configComponent?.component_name ===
        AMBER_USER_WEBSITE_CONFIGURABLE_COMPONENTS["search_page_top_banner"] &&
      configComponent?.regionId === regionId,
  )[0];

  const showUalSalesBanner =
    isWhitelabel &&
    UAL_SALES_BANNER_PARTNER_IDS.includes(Number(partner_id)) &&
    filters?.housingType === "university_provider";

  return (
    <>
      {searchPageTopBannerConfig ? (
        <span className={styles.searchPageConfigBanner}>
          <div className={styles.radialGradient1} />
          <div className={styles.radialGradient2} />
          <Image
            src={
              searchPageTopBannerConfig?.data?.image ||
              `${config.IMAGE_STATIC_URL}/configurable_components_images/timer-gif.gif`
            }
            height={48}
            width={48}
          />
          <div>
            {searchPageTopBannerConfig?.data?.title?.text && (
              <h3 className={formatClassNames(isWhitelabel ? "wl-title-font" : "", styles.title)}>
                {searchPageTopBannerConfig.data.title.text}{" "}
                {searchPageTopBannerConfig.data.title.highlighted_text && (
                  <span className={styles.redText}>
                    {searchPageTopBannerConfig.data.title.highlighted_text}
                  </span>
                )}
              </h3>
            )}
            {searchPageTopBannerConfig?.data?.subtitle?.text && (
              <p className={styles.subTitle}>{searchPageTopBannerConfig.data.subtitle.text}</p>
            )}
          </div>
        </span>
      ) : (
        <></>
      )}
      {showUalSalesBanner && (
        <div className={styles.ualSalesBanner}>
          <Image
            src="http://static-assets.amberstudent.com/images/amber-fest/en/ual-sales-banner.png"
            alt="UAL Sales Banner"
            width="100%"
            height="auto"
          />
        </div>
      )}
    </>
  );
};

export default wrapperHOC(ApplicationConfigBanner, {
  componentName: "SearchListContainer",
  showForChina: true,
});
